// these are generic but reusable event actions
const Actions = {
	CHANGE: "Action:Change",
	COMPLETE: "Action:Complete",
	ENTER: "Action:Enter",
	ERROR: "Action:Error",
}

export class ActionBus {
	/** @type {Map<String, Array<Function>>} */
	#listeners = new Map();
	
	on (type, callback) {
		const callbacks = this.#listeners.get(type) ?? [];
		callbacks.push(callback);
		this.#listeners.set(type, callbacks);
		return this;
	}
	
	one (type, callback) {
		if (!this.#listeners.has(type)) {
			this.on(type, callback);
		}
		return this;
	}
	
	off (type, callback) {
		const callbacks = this.#listeners.get(type);
		if (callbacks) {
			this.#listeners.set(type, callbacks.filter(cb => cb !== callback));
		}
		return this;
	}

	send (type, ...args) {
		this.#listeners.get(type)?.forEach(f => f?.(...args));
		return this;
	}
	
	clone () {
		const newBus = new ActionBus();
		newBus.#listeners = this.#listeners;
		return newBus;
	}
}
ActionBus.Actions = Actions;